import React from "react";

export const ChartLoaderTemplate = function() {
  return (
    <>
      <circle cx="150" cy="86" r="8" />
      <circle cx="194" cy="86" r="8" />
      <circle cx="238" cy="86" r="8" />
    </>
  );
};
